/**
 * Every route of the web app, as data. The router draws a screen for each `routeId`, and the
 * route selectors match the current path against the same list, so both agree on what a path means.
 * `access` says who may open it: `public` (signed out only), `onboarding` (signed in, before setup),
 * `app` (signed in, inside the app shell) or `open` (anyone).
 */
const routes = [
  { routeId: 'signIn', path: '/sign-in', access: 'public' },
  { routeId: 'signUp', path: '/sign-up', access: 'public' },
  { routeId: 'forgotPassword', path: '/forgot-password', access: 'public' },
  { routeId: 'resetPassword', path: '/reset-password', access: 'open' },
  { routeId: 'acceptInvite', path: '/accept-invite', access: 'open' },
  { routeId: 'onboarding', path: '/onboarding', access: 'onboarding' },
  { routeId: 'home', path: '/', access: 'app' },
  { routeId: 'home', path: '/threads/:threadId', access: 'app' },
  { routeId: 'automations', path: '/automations', access: 'app' },
  { routeId: 'automations', path: '/automations/:automationType/:automationId', access: 'app' },
  { routeId: 'automations', path: '/automations/:automationType/:automationId/:automationMode', access: 'app' },
  { routeId: 'connections', path: '/connections', access: 'app' },
  { routeId: 'connections', path: '/connections/:appSlug', access: 'app' },
  { routeId: 'skills', path: '/skills', access: 'app' },
  { routeId: 'skills', path: '/skills/:skillId', access: 'app' },
  { routeId: 'knowledge', path: '/knowledge', access: 'app' },
  { routeId: 'knowledge', path: '/knowledge/:documentName', access: 'app' },
  { routeId: 'settings', path: '/settings', access: 'app' },
  { routeId: 'settings', path: '/settings/:section', access: 'app' },
  { routeId: 'oauthReturn', path: '/oauth/:appSlug/:outcome', access: 'open' },
  { routeId: 'gallery', path: '/gallery/*', access: 'open' }
];

export default routes;
